"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.roles.super_admin': '超级管理员',
    'user.roles.parent_user': '管理员',
    'user.roles.enterprise': '企业',
    'user.roles.user': '用户',
};
